// Bearing ratings and weights. Every number is copied from the maker's page named by the source key; nothing is estimated.
// A bearing that isn't here has no sourced rating: the app shows a dash. Add rows only from a catalogue, with the source.
// row: [maker's designation, C kN, C0 kN, reference speed r/min, limiting speed r/min, net weight kg, source key]
// skf: skf.com/group/products/rolling-bearings/productid-<designation>, read 2 Oct 2026
var BRGSRC={skf:'SKF product page, skf.com, read 2 Oct 2026'};
var BRGDAT={
// 60xx
'6000':['6000',4.75,1.96,67000,40000,0.0178,'skf'],
'6001':['6001',5.4,2.36,60000,38000,0.0195,'skf'],
'6002':['6002',5.85,2.85,50000,32000,0.03,'skf'],
'6003':['6003',6.37,3.25,45000,28000,0.0375,'skf'],
'6004':['6004',9.95,5,38000,24000,0.0656,'skf'],
'6005':['6005',11.9,6.55,32000,20000,0.0776,'skf'],
'6006':['6006',13.8,8.3,28000,17000,0.113,'skf'],
'6007':['6007',16.8,10.2,24000,15000,0.148,'skf'],
'6008':['6008',17.8,11,22000,14000,0.185,'skf'],
'6009':['6009',22.1,14.6,20000,12000,0.235,'skf'],
'6010':['6010',22.9,16,18000,11000,0.255,'skf'],
'6011':['6011',29.6,21.2,16000,10000,0.371,'skf'],
'6012':['6012',30.7,23.2,15000,9500,0.395,'skf'],
'6013':['6013',31.9,25,14000,9000,0.427,'skf'],
'6014':['6014',39.7,31,13000,8000,0.597,'skf'],
'6015':['6015',41.6,33.5,12000,7500,0.631,'skf'],
'6016':['6016',49.4,40,11000,7000,0.85,'skf'],
'6017':['6017',52,43,11000,6700,0.896,'skf'],
'6018':['6018',60.5,50,10000,6300,1.14,'skf'],
'6019':['6019',63.7,54,9500,6000,1.19,'skf'],
'6020':['6020',63.7,54,9500,5600,1.22,'skf'],
// 62xx
'6200':['6200',5.4,2.36,56000,36000,0.0312,'skf'],
'6201':['6201',7.28,3.1,50000,32000,0.0354,'skf'],
'6202':['6202',8.06,3.75,43000,28000,0.0436,'skf'],
'6203':['6203',9.95,4.75,38000,24000,0.062,'skf'],
'6204':['6204',13.5,6.55,32000,20000,0.102,'skf'],
'6205':['6205',14.8,7.8,28000,18000,0.125,'skf'],
'6206':['6206',20.3,11.2,24000,15000,0.193,'skf'],
'6207':['6207',27,15.3,20000,13000,0.281,'skf'],
'6208':['6208',32.5,19,18000,11000,0.352,'skf'],
'6209':['6209',35.1,21.6,17000,11000,0.404,'skf'],
'6210':['6210',37.1,23.2,15000,10000,0.442,'skf'],
'6211':['6211',46.2,29,14000,9000,0.591,'skf'],
'6212':['6212',55.3,36,13000,8000,0.755,'skf'],
'6213':['6213',58.5,40.5,12000,7500,0.99,'skf'],
'6214':['6214',63.7,45,11000,7000,1.06,'skf'],
'6215':['6215',68.9,49,10000,6700,1.16,'skf'],
'6216':['6216',72.8,55,9500,6000,1.43,'skf'],
'6217':['6217',87.1,64,9000,5600,1.74,'skf'],
'6218':['6218',101,73.5,8500,5300,2.16,'skf'],
'6219':['6219',114,81.5,8000,5000,2.55,'skf'],
'6220':['6220',127,93,7500,4800,3.16,'skf'],
// 63xx
'6300':['6300',8.52,3.4,50000,32000,0.0508,'skf'],
'6301':['6301',10.1,4.15,45000,28000,0.0574,'skf'],
'6302':['6302',11.9,5.4,38000,24000,0.0792,'skf'],
'6303':['6303',14.3,6.55,34000,22000,0.11,'skf'],
'6304':['6304',16.8,7.8,30000,19000,0.139,'skf'],
'6305':['6305',23.4,11.6,24000,16000,0.218,'skf'],
'6306':['6306',29.6,16,20000,13000,0.34,'skf'],
'6307':['6307',35.1,19,19000,12000,0.444,'skf'],
'6308':['6308',42.3,24,17000,11000,0.611,'skf'],
'6309':['6309',55.3,31.5,15000,9500,0.817,'skf'],
'6310':['6310',65,38,13000,8500,1.05,'skf'],
'6311':['6311',74.1,45,12000,8000,1.34,'skf'],
'6312':['6312',85.2,52,11000,7000,1.67,'skf'],
'6313':['6313',97.5,60,10000,6700,2.05,'skf'],
'6314':['6314',111,68,9500,6300,2.49,'skf'],
'6315':['6315',119,76.5,9000,5600,2.99,'skf'],
'6316':['6316',130,86.5,8500,5300,3.54,'skf'],
// 511xx
'51100':['51100',8.71,12.2,9500,13000,0.02,'skf'],
'51101':['51101',10.4,16.6,9000,13000,0.022,'skf'],
'51102':['51102',10.6,18.3,8500,12000,0.0226,'skf'],
'51103':['51103',11.4,21.2,8500,12000,0.0259,'skf'],
'51104':['51104',15.1,29,7500,10000,0.0382,'skf'],
'51105':['51105',18.2,39,6300,9000,0.0583,'skf'],
'51106':['51106',19,43,6000,8500,0.063,'skf'],
'51107':['51107',19.9,51,5600,7500,0.0829,'skf'],
'51108':['51108',25.5,63,5000,7000,0.119,'skf'],
'51109':['51109',26.5,69.5,4500,6300,0.142,'skf'],
'51110':['51110',27,75,4300,6300,0.155,'skf'],
'51111':['51111',30.2,81.5,3800,5300,0.217,'skf'],
'51112':['51112',41.6,122,3600,5000,0.293,'skf'],
'51113':['51113',37.7,108,3400,4800,0.321,'skf'],
'51114':['51114',40.3,120,3400,4500,0.336,'skf'],
'51115':['51115',44.2,134,3200,4300,0.392,'skf'],
'51116':['51116',44.9,140,3000,4300,0.401,'skf'],
'51117':['51117',44.9,146,3000,4300,0.413,'skf'],
'51118':['51118',59.2,208,2600,3800,0.642,'skf'],
'51120':['51120',80.6,265,2400,3200,0.954,'skf'],
// 512xx
'51200':['51200',12.7,18.6,8000,11000,0.029,'skf'],
'51201':['51201',13.3,20.8,8000,11000,0.033,'skf'],
'51202':['51202',15.9,25,7000,10000,0.044,'skf'],
'51203':['51203',16.3,27,6700,9500,0.0514,'skf'],
'51204':['51204',21.2,37.5,6000,8000,0.078,'skf'],
'51205':['51205',26.5,50,5300,7500,0.111,'skf'],
'51206':['51206',25.1,51,4800,6700,0.129,'skf'],
'51207':['51207',35.1,73.5,4000,5600,0.208,'skf'],
'51208':['51208',44.2,96.5,3800,5300,0.268,'skf'],
'51209':['51209',39,86.5,3600,5000,0.288,'skf'],
'51210':['51210',49.4,116,3400,4500,0.356,'skf'],
'51211':['51211',58.5,134,2800,4000,0.579,'skf'],
'51212':['51212',59.2,140,2800,3800,0.634,'skf'],
'51213':['51213',60.5,150,2600,3600,0.714,'skf'],
'51214':['51214',62.4,160,2600,3600,0.758,'skf'],
'51215':['51215',63.7,170,2400,3400,0.799,'skf'],
'51216':['51216',76.1,208,2400,3400,0.874,'skf'],
'51217':['51217',97.5,275,2200,3000,1.21,'skf'],
'51218':['51218',112,290,2000,2800,1.63,'skf'],
'51220':['51220',119,325,1800,2400,2.14,'skf'],
// 513xx
'51305':['51305',34.5,60,4500,6300,0.163,'skf'],
'51306':['51306',35.8,65.5,3800,5300,0.252,'skf'],
'51307':['51307',49.4,96.5,3400,4800,0.364,'skf'],
'51308':['51308',61.8,122,3000,4300,0.523,'skf'],
'51309':['51309',76.1,153,2800,4000,0.642,'skf'],
'51310':['51310',81.9,170,2600,3600,0.92,'skf'],
'51311':['51311',101,224,2200,3200,1.25,'skf'],
'51312':['51312',101,224,2200,3000,1.31,'skf'],
'51313':['51313',106,240,2000,3000,1.42,'skf'],
'51314':['51314',135,320,1900,2600,1.94,'skf'],
'51315':['51315',163,390,1700,2400,2.53,'skf'],
'51316':['51316',159,390,1700,2400,2.64,'skf'],
'51317':['51317',174,405,1600,2200,3.43,'skf'],
'51318':['51318',182,440,1500,2200,3.67,'skf'],
'51320':['51320',225,570,1400,1900,4.92,'skf'],
// 514xx
'51405':['51405',42.3,67,3600,5000,0.309,'skf'],
'51406':['51406',70.2,122,3000,4300,0.503,'skf'],
'51407':['51407',76.1,137,2600,3600,0.742,'skf'],
'51408':['51408',95.6,183,2400,3400,1.07,'skf'],
'51409':['51409',124,240,2200,3000,1.4,'skf'],
'51410':['51410',159,340,2000,2800,1.99,'skf'],
'51411':['51411',195,400,1800,2400,2.6,'skf'],
'51412':['51412 M',199,430,1600,2200,3.52,'skf'],
'51413':['51413 M',216,490,1500,2200,4.47,'skf'],
'51414':['51414 M',234,550,1400,2000,5.48,'skf'],
'51415':['51415 M',251,610,1300,1800,6.76,'skf'],
'51416':['51416',302,750,1200,1700,7.21,'skf'],
'51417':['51417 M',286,750,1200,1600,9.32,'skf'],
'51418':['51418 M',291,750,1100,1500,11.1,'skf'],
'51420':['51420 M',371,1060,950,1400,14.8,'skf'],
// 811xx
'81102':['81102 TN',11.2,27,4300,8500,0.02,'skf'],
'81103':['81103 TN',12.2,31.5,4300,8500,0.0242,'skf'],
'81104':['81104 TN',18.6,48,3800,7500,0.04,'skf'],
'81105':['81105 TN',25,69.5,3200,6300,0.052,'skf'],
'81106':['81106 TN',27,78,3000,6000,0.0577,'skf'],
'81107':['81107 TN',29,93,2800,5600,0.073,'skf'],
'81108':['81108 TN',43,137,2400,5000,0.107,'skf'],
'81109':['81109 TN',45,153,2200,4500,0.13,'skf'],
'81110':['81110 TN',47.5,166,2200,4300,0.144,'skf'],
'81111':['81111 TN',69.5,285,1500,3000,0.231,'skf'],
'81112':['81112 TN',80,300,1800,3600,0.27,'skf'],
'81113':['81113 TN',83,320,1700,3400,0.312,'skf'],
'81114':['81114 TN',86.5,345,1700,3400,0.342,'skf'],
'81115':['81115 TN',83,335,1600,3200,0.391,'skf'],
'81116':['81116 TN',81.5,335,1500,3000,0.4,'skf'],
'81117':['81117 TN',88,365,1500,3000,0.42,'skf'],
'81118':['81118 TN',110,450,1300,2600,0.613,'skf'],
'81120':['81120 TN',156,630,1200,2400,0.903,'skf'],
// 812xx
'81206':['81206 TN',50,134,2400,4800,0.123,'skf'],
'81207':['81207 TN',62,190,2000,4000,0.208,'skf'],
'81208':['81208 TN',83,255,1900,3800,0.253,'skf'],
'81209':['81209 TN',83,255,1800,3600,0.288,'skf'],
'81210':['81210 TN',91.5,300,1700,3400,0.364,'skf'],
'81211':['81211 TN',122,390,1400,2800,0.568,'skf'],
'81212':['81212 TN',137,465,1400,2800,0.642,'skf'],
'81213':['81213 TN',140,490,1300,2600,0.721,'skf'],
'81214':['81214 TN',146,530,1300,2600,0.77,'skf'],
'81215':['81215 TN',137,490,1200,2400,0.81,'skf'],
'81216':['81216 TN',160,610,1200,2400,0.9,'skf'],
'81217':['81217 TN',170,640,1100,2200,1.21,'skf'],
'81218':['81218 TN',232,865,1000,2000,1.77,'skf'],
'81220':['81220 TN',270,1060,900,1800,2.2,'skf'],
// 292xx
'29230':['29230 E',408,1600,1800,2800,4.29,'skf'],
'29236':['29236 E',495,2040,1600,2600,5.83,'skf'],
'29240':['29240 E',656,2650,1400,2200,8.52,'skf'],
// 293xx
'29317':['29317 E',380,1060,2400,4000,2.76,'skf'],
'29318':['29318 E',400,1080,2400,4000,2.9,'skf'],
'29320':['29320 E',465,1290,2200,3600,3.58,'skf'],
'29322':['29322 E',610,1730,1900,3200,5.3,'skf'],
'29324':['29324 E',765,2120,1700,2800,7.26,'skf'],
'29326':['29326 E',865,2500,1600,2600,8.79,'skf'],
'29328':['29328 E',980,2850,1500,2600,10.4,'skf'],
'29330':['29330 E',1000,2850,1500,2400,10.8,'skf'],
'29332':['29332 E',1180,3450,1300,2200,14.3,'skf'],
'29334':['29334 E',1200,3550,1300,2200,14.2,'skf'],
'29336':['29336 E',1430,4300,1200,2000,19,'skf'],
'29338':['29338 E',1630,4750,1100,1900,22.9,'skf'],
'29340':['29340 E',1860,5500,1000,1700,28.4,'skf']
};
